import axios from "axios";
import { uri } from "../help/Api";
import { sto } from "../Context/InshData";

export const URL = uri + "BasicData";

export function list() {
  return axios.get(URL);
}

export function create(data) {
  return axios.post(URL, data);
}

export function update(data) {
  return axios.put(URL, data);
}
export function removeSafe(id) {
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `?id=${id}&&tb=${"Safes"}`
  } else {
    Urls = `?id=${id}&&tb=${"Safes"}&&db_name=${sto?.db_name}`
  }
  return axios.delete(URL + Urls);
}
export function removeStock(id) {
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `?id=${id}&&tb=${"Stocks"}`
  } else {
    Urls = `?id=${id}&&tb=${"Stocks"}&&db_name=${sto?.db_name}`
  }
  return axios.delete(URL +Urls);
}
export function removeCost(id) {
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `?id=${id}&&tb=${"costcenters"}`
  } else {
    Urls = `?id=${id}&&tb=${"costcenters"}&&db_name=${sto?.db_name}`
  }
  return axios.delete(URL + Urls);
}
export function removeBank(id) {
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `?id=${id}&&tb=${"Banks"}`
  } else {
    Urls = `?id=${id}&&tb=${"Banks"}&&db_name=${sto?.db_name}`
  }
  return axios.delete(URL + Urls);
}

export default {
  list,
  create,
  update,
  removeSafe,
  removeStock,
  removeCost,
  removeBank,
};
